<template>
  <v-container
    class="fill-height fondo-oscuro" 
    :style="{'background': `url(${this.imagen_fondo}) transparent no-repeat center`}"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="10"
        sm="5"
        md="3"
      >
        <v-card class="elevation-12 "  >
          <v-card-text>
              <!-- <span class="headline text-center my-3">Nueva contraseña</span> -->
            <p class="  headline">Nueva contraseña</p>
            <v-form>
              <v-text-field        
                placeholder="Contraseña nueva" 
                type="password"
                background-color="white"
                outlined
                v-model="clave"
                :rules="[ v => !!v || 'La contraseña es requerida',
                rules.password]"                    
              ></v-text-field>
              <v-text-field        
                placeholder="Confirmar contraseña" 
                type="password"
                background-color="white"
                outlined
                v-model="clave2"
              ></v-text-field>                    
            </v-form>
          <div class="orange text-center py-3 my-2" v-if="mostrar_error">
              <span class="white--text body-1">{{ mensaje_error }}</span>
          </div> 
                  
            <v-col cols="12"  class="mx-0 my-0 px-0 pt-0">
              <button
                  class="menta btn-ingresar py-4" 
                  :style="{ 'opacity': `${opacidad}`}"
                  :disabled="valido"
                  v-on:click="validar()"              
              >
                Guardar
              </button>
            </v-col>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

  </v-container>  
</template>

<script>
import Conexion_api from "@/api/Conexion_api.js";
import Usuario from '@/objetos/usuario'
import redireccionar from '@/funciones/redireccionar'
import host from '@/objetos/host.js';
import configuraciones from '@/objetos/configuraciones.js';
const { HOST } = host;

export default {
    data: () => ({
        clave:null,
        clave2:null,
        mostrar_error:false,
        mensaje_error:null,
        usuario: Usuario,
        imagen_fondo: "",
        imagen_perfil: "",
        rules: {
          password: value => {
            if(!value) return true 
            const pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
            return pattern.test(value) || 'La contraseña debe contener mínimo 8 carácteres, 1 número'
            
          }                 
        }        
    }),
    created(){
    this.imagen_fondo = this.buscar_configuracion("imagen_fondo_login");    
    let r = Math.random().toString(36).substring(7);
    this.imagen_fondo = this.imagen_fondo.valor ? `${this.imagen_fondo.valor}?v=${r}` : "https://pwstplataforma.s3.us-east-2.amazonaws.com/general/fondo_login_pedidos.png"

    this.imagen_perfil = this.buscar_configuracion("logo_para_login");
    this.imagen_perfil = this.imagen_perfil.valor ? `${this.imagen_perfil.valor}?v=${r}`: "";
  },
    computed: {
      valido: function () {
        if (this.clave && this.clave2 && this.clave == this.clave2){
            return false;
        }
        return true
      },
      opacidad: function () {
        if (this.clave && this.clave2 && this.clave.length >= 8 && this.clave == this.clave2){
            return 1;
        }
        return 0.7
      }
    }, 
    watch:{
      clave2(clave){
          if (this.clave != clave) {
            this.mostrar_error=true
            this.mensaje_error = "La contraseñas no coincide"
          } else {
            this.mostrar_error=false 
            this.mensaje_error = ""
          }

      },
    },
    methods:{
      validar(){
        this.mostrar_error = false
        let base = HOST.split(".")[0] + "01";
        Conexion_api({
          body: {
            clave   : String(this.clave),
            clave2  : String(this.clave2),
            usuario : String(this.usuario.codigo),
            base    : String(base),
          },
          evento: "login/nueva_clave_pedidos"
        }).then(respuesta => {
            if (!respuesta.data.error) {
              this.$cookie.set('pwst',respuesta.data.token, { expires: '1h' });              
              redireccionar("/pedidos_web")
            } else {
                this.mostrar_error = true
                this.mensaje_error = respuesta.data.error                
            }                         
        }).catch(err => {
            err = String(err)
            console.error(err)
        })         
      },      
      buscar_configuracion(nombre){
        return configuraciones.datos.find(config => {return config.nombre == nombre})
      } 
    }

}
</script>

<style>

</style>